// Phone + tablet chrome. Desktop is untouched: everything here is either invisible above the
// breakpoints in style.css (the ☰ menu button, the Layers button, the drawer backdrop) or a
// no-op there (closeDrawer). Two pieces:
//   * ☰ menu: on narrow screens the top bar keeps only the brand, project picker and markup
//     tools; everything else (Ingest, Export, view settings, Sign out...) folds into a panel
//     that this button opens (body.topbar-open).
//   * Layers drawer: below 768px the sidebar slides over the map instead of taking 300-400px
//     of a 390px screen (body.drawer-open).

/** True on a touch-first device (phone / tablet): no hover, coarse pointer. */
export const isTouch = window.matchMedia("(hover: none) and (pointer: coarse)").matches;

/** Width at which the sidebar becomes a slide-over drawer (matches style.css). */
const DRAWER_MQ = window.matchMedia("(max-width: 768px)");

export function mountMobileChrome(topbar: HTMLElement, after: Element | null, container: HTMLElement): void {
  const menuBtn = document.createElement("button");
  menuBtn.className = "tool-btn menu-toggle";
  menuBtn.textContent = "☰";
  menuBtn.title = "More tools and view settings";
  menuBtn.setAttribute("aria-expanded", "false");
  menuBtn.addEventListener("click", () => {
    const open = document.body.classList.toggle("topbar-open");
    menuBtn.setAttribute("aria-expanded", String(open));
    menuBtn.textContent = open ? "✕" : "☰";
  });
  if (after) after.after(menuBtn);
  else topbar.append(menuBtn);

  const layersBtn = document.createElement("button");
  layersBtn.className = "layers-fab";
  layersBtn.textContent = "☰ Layers";
  layersBtn.addEventListener("click", () => document.body.classList.toggle("drawer-open"));
  container.append(layersBtn);

  const backdrop = document.createElement("div");
  backdrop.className = "drawer-backdrop";
  backdrop.addEventListener("click", closeDrawer);
  document.getElementById("main")?.append(backdrop);

  const sidebar = document.getElementById("sidebar");
  if (sidebar) {
    const close = document.createElement("button");
    close.className = "drawer-close";
    close.textContent = "✕";
    close.title = "Close";
    close.addEventListener("click", closeDrawer);
    sidebar.prepend(close);
  }

  // Leaving the narrow layout (rotating a tablet) must not strand the page in a drawer state.
  DRAWER_MQ.addEventListener("change", () => closeDrawer());
}

/** Close the Layers drawer (phones only - a no-op when the sidebar is docked). */
export function closeDrawer(): void {
  document.body.classList.remove("drawer-open");
}

/** After picking a layer on a phone, get the drawer out of the way so the map + review bar show. */
export function closeDrawerIfNarrow(): void {
  if (DRAWER_MQ.matches) closeDrawer();
}
